import { Component, ElementRef, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RestapiService } from '../services/restapi.service';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-custom-detector',
  templateUrl: './custom-detector.component.html',
  styleUrls: ['./custom-detector.component.css']
})
export class CustomDetectorComponent implements OnInit {

  @ViewChildren("myselect") myselect: QueryList<ElementRef>;

  uploadForm: FormGroup;
  submitted = false;
  showsuccess = false;
  showSuccessMessage: string;
  showErrorMessage: string;
  showerror: boolean;
  jsonData;
  applicationList: any = [];
  applicationDetailsList: any = [];
  customeDetectorApplicationList: any = [];
  filterCustomeDetectorApplicationArray: any = [];
  filterCustomeDetectorApplicationList: any = [];
  appNameList: any = [];
  newApplicationName: string;
  indexList:number;
  selectedAppName:string="";
  selectedRow:string[] = [];
  file_name : String ="No file selected.";

  constructor(private apiService: RestapiService,
    private router: Router,
    private _dataService: DataService
    ) { 
  }

  ngOnInit(): void {
    this.jsonData = null;
    this.selectedRow=[];
    this.createForm();
    this.applicationList=JSON.parse(localStorage.getItem('applicationList') || '[]');
    this.appNameList=JSON.parse(localStorage.getItem('appNameList') || '[]');
    this.selectedRow=JSON.parse(localStorage.getItem('newApplicationNameArray') || '[]');
    for(var i=0; i<this.applicationList.length; i++){
      this.selectedRow.push(this.applicationList[i].web_app);
    }
  }

  // download template file
  downloadMyFile(){
 
  }
  

  closeSuccess() {
    this.showsuccess = false;
  }

  closeError() {
    this.showerror = false;
  }
  
  
  // to upload file on backend
    onFileSelect(event: any) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[0];
        this.uploadForm.get('pcapFile')!.setValue(file);
        this.file_name=file.name;
      }
    }
  
    onSubmit() {
      this.submitted = true;
      this.applicationList=[];
      if (this.uploadForm.invalid) {
        return;
      }
      const formData = new FormData();
      const jsonData = this.uploadForm.value;
      delete jsonData.pcapFile;
  
      formData.append('file', this.uploadForm.get('pcapFile')!.value);
      if(this.uploadForm.get('pcapFile')==null || this.uploadForm.get('pcapFile')==undefined){
           alert('Please upload the file first.');
      }
      this.selectedRow=[];
      this.apiService.submitCustomDetectorRequest(formData).subscribe(
        (resp) => {
          this.uploadForm.reset();
          this.submitted = false;
          this.showsuccess = true;
          this.showSuccessMessage = "File uploaded successfully.";
          this.jsonData = JSON.parse(JSON.stringify(resp));
          this.applicationList = this.jsonData.applicationList;
          this.appNameList=this.jsonData.appNameList;
          this.applicationDetailsList=this.jsonData.applicationDetailsList;
          localStorage.setItem('applicationList', JSON.stringify(this.jsonData.applicationList));
          localStorage.setItem('appNameList', JSON.stringify( this.jsonData.appNameList));
          localStorage.setItem('applicationDetailsList', JSON.stringify(this.jsonData.applicationDetailsList));
          console.log('....'+ this.applicationList );
          for(var i=0; i<this.applicationList.length; i++){
            this.selectedRow.push(this.applicationList[i].web_app);
          }
         
        },
        (error) => {
          // Error callback
          console.log(error);
          this.showerror = true;
          this.showErrorMessage = error.error;
        }
      );
    }
  
    get f() {
      return this.uploadForm.controls;
    }
  
    createForm() {
      this.uploadForm = new FormGroup({
        pcapFile: new FormControl('',Validators.required)
      });
    }
  
    setNewApplicationName(){
      debugger;
      if(this.selectedAppName!="" && this.selectedAppName!="Select Application Name"){
      console.log('test..',this.selectedAppName);
    
      for (var val of this.applicationList) {
        val.new_app_name.unshift( this.selectedAppName);
        val.new_app_name=val.new_app_name;
      }  
      
      localStorage.setItem('applicationList', JSON.stringify(this.applicationList));  
      this.applicationList = JSON.parse(localStorage.getItem('applicationList') || '[]');
      this.applicationList =this.applicationList ;
      var feildsArray = this.myselect.toArray();
     
      //feildsArray[this.indexList].nativeElement.value=this.selectedAppName ; 
      this.selectedRow[this.indexList]=    this.selectedAppName ; 
      this.applicationList[this.indexList].isUpdated=true;
      this.applicationList[this.indexList].new_custome_detector_name=  this.selectedAppName ;
      localStorage.setItem('newApplicationNameArray', JSON.stringify(this.selectedRow));  
      localStorage.setItem('applicationList', JSON.stringify(this.applicationList));
      console.log('applicationList..............',this.applicationList);
    

     }
     
   /*  else if(this.newApplicationName!=undefined && this.newApplicationName!=null && this.newApplicationName!=''){      
      console.log( this.applicationList[this.indexList].new_app_name);
      // this.applicationList[this.indexList].new_app_name.push(this.newApplicationName);
      var feildsArray = this.myselect.toArray();
      feildsArray[this.indexList].nativeElement.value = this.newApplicationName;
      for (var val of this.applicationList) {
        val.new_app_name.splice(val.new_app_name.length-1, 0, this.newApplicationName);
      }    
      localStorage.setItem('applicationList', JSON.stringify(this.applicationList));
     } */
     // this.newApplicationName;
     this.selectedAppName='';
     this.newApplicationName = '';
      this.closeModal('feedback');
    
    }
  
    onChangeName(name:string,listindex:number){
      localStorage.setItem('newApplicationNameArray', JSON.stringify(this.selectedRow));  
      this.indexList=listindex;
      this.applicationList[this.indexList].isUpdated=true;
      this.applicationList[this.indexList].new_custome_detector_name=  name;
      console.log('applicationList.....onchnage.........',this.applicationList);
      if(name=="Other"){
        this.openModal('feedback');
      //  var feildsArray = this.textFields.toArray();
      //  feildsArray[this.indexList].nativeElement.value ="";
      }
     
    }
  
    
  
   
  
    openModal(modalType) {
      (document.getElementById(modalType) as HTMLInputElement).style.display = 'block';
      (document.getElementById(modalType) as HTMLInputElement).style.top = '50px';
    }
  
    closeModal(modalType) {
      this.selectedAppName='';
      this.newApplicationName = '';
      (document.getElementById(modalType) as HTMLInputElement).style.display = 'none';
      //this.isChecked = false;
    }

    createCustomeDetector(){
      this.customeDetectorApplicationList=this.applicationList.filter((obj) => {
        return obj.isUpdated===true;
      });
      console.log("...applicationlist......",this.applicationList);
      console.log(".........",this.customeDetectorApplicationList);
      this.createCustomeDetectorData();
    }

    createCustomeDetectorData(){
      this.applicationDetailsList=JSON.parse(localStorage.getItem('applicationDetailsList') || '[]');
       
      this.customeDetectorApplicationList.forEach(element => {
        debugger
        const i=this.applicationDetailsList.findIndex(x => x.appName1 ===element.new_custome_detector_name);
        if(i>=1){
          const tmpobject=this.applicationDetailsList[i];
          tmpobject.url = element.url ;
          tmpobject.count =element.count ;
          tmpobject.web_app = element.web_app ;
          tmpobject.new_web_app_name =element.new_app_name ; 
          tmpobject.new_custome_detector_name=element.new_custome_detector_name;
          tmpobject.appNameFind=true;
          this.filterCustomeDetectorApplicationList.push(tmpobject); 
        }else{
          var tmpobject1={};
          tmpobject1["url"]=element.url;
          tmpobject1["count"]=element.count;
          tmpobject1["web_app"]=element.web_app;
          tmpobject1["new_web_app_name"] =element.new_app_name ; 
          tmpobject1["new_custome_detector_name"]=element.new_custome_detector_name;
          tmpobject1["appNameFind"]=false;
          this.filterCustomeDetectorApplicationList.push(tmpobject1); 

        }
      });
     ;
           
            
      

      console.log('.,....filterCustomeDetectorApplicationList..............,.,.',this.filterCustomeDetectorApplicationList);
      this._dataService.changeParam(this.filterCustomeDetectorApplicationList);
      this.router.navigate(['/customdetectorupdate']);

  /*    const formData = new FormData();
      const jsonData = this.uploadForm.value;
      delete jsonData.pcapFile;
  
      formData.append('customeDetectorData', this.customeDetectorApplicationList);
      this.apiService.submitCustomDetectorRequest(formData).subscribe(
        (resp) => {
          this.uploadForm.reset();
          this.jsonData = JSON.parse(JSON.stringify(resp));
         console.log("................",this.jsonData);
         
         
        },
        (error) => {
          // Error callback
          console.log(error);
          this.showerror = true;
          this.showErrorMessage = error.error;
        }
      ); */
    }

    addDataToFilterArray(i:any){
      this.filterCustomeDetectorApplicationArray[0].url = this.customeDetectorApplicationList[i].url ;
      this.filterCustomeDetectorApplicationArray[0].count = this.customeDetectorApplicationList[i].count ;
      this.filterCustomeDetectorApplicationArray[0].web_app = this.customeDetectorApplicationList[i].web_app ;
      this.filterCustomeDetectorApplicationArray[0].new_web_app_name = this.customeDetectorApplicationList[i].new_app_name ; 
//    this.filterCustomeDetectorApplicationArray[0].push({"url":this.customeDetectorApplicationList[i].url});
 this.filterCustomeDetectorApplicationList.push(this.filterCustomeDetectorApplicationArray[0]);  
    }

}
